'use client';
import React, { FC, ReactElement } from 'react';

import { Dialog } from '@mui/material';

const Modal: FC<{
    children: ReactElement;
    open: boolean;
    setOpen: any;
    sx?: any;
    disablePortal?: boolean;
    PapperProps?: any;
}> = ({ children, open, setOpen, sx, disablePortal, PapperProps }) => {
    const handleClose = (): void => {
        setOpen(false);
    };

    return (
        <Dialog
            disablePortal={disablePortal}
            maxWidth={false}
            open={open}
            onClose={handleClose}
            sx={sx}
            PaperProps={{
                style: PapperProps || sx,
            }}
        >
            <>{children}</>
        </Dialog>
    );
};
export default Modal;
